import { render } from "./Supply.vue?vue&type=template&id=6b243b5a&scoped=true&ts=true"
import script from "./Supply.vue?vue&type=script&lang=ts"
export * from "./Supply.vue?vue&type=script&lang=ts"

import "./Supply.vue?vue&type=style&index=0&id=6b243b5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b243b5a"]])

export default __exports__